const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYfi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "yearn-finance-yfi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M500,0c276.1,0,500,223.9,500,500s-223.9,500-500,500S0,776.1,0,500,223.9,0,500,0Z",
    style: {
      fill: "#006ae3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID-2",
    "data-name": "SVGID",
    points: "479.4 710.8 479.4 294.8 524.7 294.8 524.7 710.8 479.4 710.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    "data-name": "SVGID",
    d: "M710,433.4,570.1,470.5,538.9,325.3l41.6-9.4,16.4,68.8s37.8-62-12.6-126.2c-29.7-33-43.8-34.4-77.1-39.6-29.3-4.2-97.4,5.7-117.7,85.2-8.6,51.2,1.1,89.1,67.1,138.7L452.9,498s-73.7-51.9-92.7-88.3c-14.7-28.8-39.9-85.7,5.6-164.9,24.5-39.6,72.8-77.6,157.9-73.6C566.5,173,671,225.3,654.8,347.5c-2.8,22.9-14.7,53.4-14.7,53.4l57.4-12.8L710,433.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-4",
    "data-name": "SVGID",
    d: "M630.1,758.9c-25.6,38.9-74.9,75.6-159.8,69.4-42.8-2.9-145.8-58-126.4-179.7,3.4-22.8,16.1-52.9,16.1-52.9l-57.7,11.2L291,561.4,431.9,528l27.4,146-41.9,8.3L402.8,613s-39.4,60.9,9.2,126.5c28.8,33.8,42.8,35.5,76.1,41.6,29.1,5,97.5-3.2,119.9-82.1,9.9-50.9,1.2-89.1-63.4-140.5l5.2-55.1s72.3,53.8,90.3,90.7c13.8,29.3,37.5,86.9-10,164.8Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYfi);
export default __webpack_public_path__ + "static/media/YFI.442c449af05864f6a70e52840e8f47a5.svg";
export { ForwardRef as ReactComponent };